import { Component, EventEmitter, Input, Output } from '@angular/core';
import { Router } from '@angular/router';
import { CheckrideCard } from '../../models/checkride-card.model';

@Component({
  selector: 'app-dashboard-checkride-card',
  templateUrl: './dashboard-checkride-card.component.html',
  styleUrls: ['./dashboard-checkride-card.component.scss'],
  host: { '[class.is-expanded]': 'expanded' }
})
export class DashboardCheckrideCardComponent {
  @Input() card: CheckrideCard;
  @Input() expanded = false;
  @Input() checkrideRoute = '/bookings';
  @Input() showPlanOfActionActions = true;
  @Input() examinerLabel = '';
  @Input() showFlightSchool = true;
  @Output() expandedChange = new EventEmitter<boolean>();

  constructor(private router: Router) { }

  openCheckride(): void {
    this.router.navigateByUrl(`${this.checkrideRoute}/edit/${this.card.id}`);
  }

  openPlanOfAction(): void {
    const checkride = this.card.entity;
    if (checkride.PlanOfAction?.PlanOfActionId) {
      this.router.navigateByUrl(`/plan-of-action/plans/edit/${checkride.PlanOfAction.PlanOfActionId}`);
      return;
    }

    const acsTestId = checkride.ApplicantAcsWrittenResult?.AcsTestId;
    if (acsTestId) {
      this.router.navigateByUrl(`/plan-of-action/plans/add?CheckRideRequestId=${this.card.id}&AcsTestId=${acsTestId}`);
    }
  }
}
